import { createAction, createAsyncAction } from 'typesafe-actions';
import { ILoyaltyReward } from '../types/reducer';

export const FETCH_LOYALTY_REWARDS = createAsyncAction(
  'loyaltyRewards/FETCH_LOYALTY_REWARDS/request',
  'loyaltyRewards/FETCH_LOYALTY_REWARDS/success',
  'loyaltyRewards/FETCH_LOYALTY_REWARDS/failure',
  'loyaltyRewards/FETCH_LOYALTY_REWARDS/cancel',
)<null, ILoyaltyReward | null, Error, void>();

const PREFIX = 'loyaltyRewards';

export const clearLoyaltyRewardsAction = createAction(`${PREFIX}/CLEAR_LOYALTY_REWARDS`)();
